/**
 * View (tabela de resultados) para a tela Gestão de Caixas Picking.
 */

import { STATUS_BOX_LABEL, renderBoxActionButtons, escHtml, fmtDt } from '../utils/output-picking-box-ops.js';

const STATUS_CLASS = { 10: 'badge-open', 20: 'badge-closed', 30: 'badge-canceled' };

export default async function(records) {
	return `
		<style>
			.view th:nth-child(1)  { width: 1rem; }
			.view td:nth-child(2)  { text-align: left; max-width: 10rem; }
			.view td:nth-child(3)  { text-align: left; }
			.view td:nth-child(4)  { text-align: left; }
			.view td:nth-child(5)  { text-align: right; }
			.view td:nth-child(6)  { text-align: center; }
			.view td:nth-child(7)  { text-align: left; max-width: 10rem; }
			.view td:nth-child(8)  { text-align: center; }
			.view td:nth-child(9)  { text-align: center; }
			.view td:nth-child(10) { text-align: center; }
			.view td:nth-child(11) { text-align: right; }
			.view td:nth-child(12) { text-align: right; }
			.view td:nth-child(13) { text-align: center; }
			.badge-box { display:inline-block; padding:2px 7px; border-radius:3px;
				font-size:0.82em; font-weight:600; }
			.badge-open     { background:#d4edda; color:#155724; }
			.badge-closed   { background:#cce5ff; color:#004085; }
			.badge-canceled { background:#f8d7da; color:#721c24; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="0" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="1" data-visible="${this.visible[1]}">Nº Caixa</th>
					<th data-index="2" data-visible="${this.visible[2]}">Nº Lacre</th>
					<th data-index="3" data-visible="${this.visible[3]}">Saída</th>
					<th data-index="4" data-visible="${this.visible[4]}">Status</th>
					<th data-index="5" data-visible="${this.visible[5]}">Aberta por</th>
					<th data-index="8" data-visible="${this.visible[8]}">Aberta em</th>
					<th data-index="9" data-visible="${this.visible[9]}">Lacrada em</th>
					<th data-index="10" data-visible="${this.visible[10]}">Cancelada em</th>
					<th data-index="11" data-visible="${this.visible[11]}">Qtd.&nbsp;Itens</th>
					<th data-index="12" data-visible="${this.visible[12]}">Qtd.&nbsp;Total</th>
					<th>Ações</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => {
				const rowId = JSON.stringify([record.company_id, record.output_id, record.id]);
				const statusLabel = STATUS_BOX_LABEL[record.status] || record.status;
				const statusCls   = STATUS_CLASS[record.status]  || '';
				const companyNick = await this.key('companies', record.company_id, 'nick') || '';
				const openedBy = record.opened_by_username || (record.opened_by
					? (await this.key('users', record.opened_by, 'username') || record.opened_by)
					: '');
				const dataId = escHtml(JSON.stringify([record.company_id, record.output_id, record.id]));
				const actionBtns = renderBoxActionButtons(record, dataId);
				return `<tr data-id='${escHtml(rowId)}'>
					<td><input type="checkbox"${this.isChecked(rowId)}></td>
					<td data-visible='${this.visible[0]}'>${escHtml(companyNick)}</td>
					<td data-visible='${this.visible[1]}'><a class="link-detail-box" data-id='${escHtml(rowId)}' href="#" style="cursor:pointer;color:inherit;text-decoration:underline dotted">${escHtml(record.code)}</a></td>
					<td data-visible='${this.visible[2]}'>${escHtml(record.seal_code || '')}</td>
					<td data-visible='${this.visible[3]}'>${record.output_id}</td>
					<td data-visible='${this.visible[4]}'><span class="badge-box ${statusCls}">${statusLabel}</span></td>
					<td data-visible='${this.visible[5]}'>${escHtml(openedBy)}</td>
					<td data-visible='${this.visible[8]}'>${fmtDt(record.opened_at)}</td>
					<td data-visible='${this.visible[9]}'>${fmtDt(record.closed_at)}</td>
					<td data-visible='${this.visible[10]}'>${fmtDt(record.canceled_at)}</td>
					<td data-visible='${this.visible[11]}'>${record.total_items}</td>
					<td data-visible='${this.visible[12]}'>${record.total_quantity}</td>
					<td style="white-space:nowrap">${actionBtns}</td>
				</tr>`;
			}))).join('') +
			`
			</tbody>
		</table>
	`;
}
